export default __webpack_public_path__ + "static/media/share-alt-solid.40c93df5.svg";